import { render, staticRenderFns } from "./ProductFilesTab.vue?vue&type=template&id=0a3faf30&scoped=true&"
import script from "./ProductFilesTab.vue?vue&type=script&lang=js&"
export * from "./ProductFilesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3faf30",
  null
  
)

export default component.exports